

// Menu hover effect
document.addEventListener("DOMContentLoaded", () => {  
  const menu = document.querySelector(".header__inline-menu");  
  
  if (menu) {  
    const items = menu.querySelectorAll("details");
    items.forEach(item => {  
      item.addEventListener("mouseover", () => {
        item.querySelector('summary').setAttribute("aria-expanded",true);
        item.setAttribute("open", true);  
        
        // Ensuring that the listener for mouseleave on the UL is set only once  
        const ul = item.querySelector("ul");  
        if (ul) {  
          ul.addEventListener("mouseleave", () => {  
            item.removeAttribute("open");  
          });  
        }  
      });  

      item.addEventListener("mouseleave", () => {  
        item.removeAttribute("open");  
        item.querySelector('summary').setAttribute("aria-expanded",false);
      });  
    });  
  }
});